
export const Types = {
    OPEN_SECTION_SCROLL: "OPEN_SECTION_SCROLL",
    TOGGLE_SECTION_SCROLL: "TOGGLE_SECTION_SCROLL"
};

export const openSectionScrollAction = () => ({
    type: Types.OPEN_SECTION_SCROLL
});

export const toggleSectionScroll = () => ({
    type: Types.TOGGLE_SECTION_SCROLL
});


// WEBPACK FOOTER //
// ./public/scroll/actions.js